import React from 'react';
export const Text = ({ level = '1', fontFamilyVariant = 'primary', fontWeight = 'normal', textColorVariant = 'primary', className, children, }) => {
    return (React.createElement("span", { className: `cb-${textColorVariant}-text-color cb-${fontWeight}-text-weight cb-${fontFamilyVariant}-text-font cb-text-${level}${className ? ` ${className}` : ''}` }, children));
};
